import { setActiveCustomerTab } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';
import { getData, postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { routePrefix } from '@/utils/routes/routes';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router';
import { toast } from 'react-toastify';

const FooterSection = ({
  footerTopWidgets = [],
  footerWidgets = [],
  ecommerceSetting = {},
  generalSetting = {},
  menuItems = [],
  socialLinks = [],
  totalQty = 0,
  subTotal = 0.0,
  currency = { symbol: '$' },
}) => {
  const isLoggedIn = useSelector((state: RootState) => state.common.isLoading);
  const dispatch = useDispatch();
  const getMenuLinks = (menuId: any) =>
    menuItems.filter((item) => item.menu_id === menuId);

  const [preFooter, setPreFooter] = useState(null);
  const [footer, setFooter] = useState(null);

  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const header = useSelector((state: RootState) => state.common.header);

  const getPreFooterSection = async () => {
    try {
      const response = await getData(end_points.preFooter.url);
      setPreFooter(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getFooterSection = async () => {
    try {
      const response = await getData('footer');
      setFooter(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await postData('newsletter', {
        email,
      });

      if (response.status === 200) {
        toast.success('Subscribed Succesfully');
        setStatus('success');
        setEmail(''); // clear the input
      } else {
        setStatus('error');
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      setStatus('error');
    }
  };

  useEffect(() => {
    getPreFooterSection();
    getFooterSection();
  }, []);

  return (
    <>
      <section className="promo-area mt-5 pt-5 pb-5 d-none">
        <div className="container">
          <div className="row">
            {/* <div className="col-md-3 col-6 d-flex pt-3 pb-3 align-items-center">
              <div className="promo-icon">
                <img
                  src="https://john.demo-cst-systems.dreamstechnologies.com/frontend/images/features/202401150154290.png"
                  alt="Free Shipping"
                />
              </div>
              <div className="promo-content">
                <h5>Free Shipping</h5>
                <span>Free shipping on all orders over $200</span>
              </div>
            </div>
            <div className="col-md-3 col-6 d-flex pt-3 pb-3 align-items-center">
              <div className="promo-icon">
                <img
                  src="https://john.demo-cst-systems.dreamstechnologies.com/frontend/images/features/202401150154531.png"
                  alt="Daily Offers"
                />
              </div>
              <div className="promo-content">
                <h5>Daily Offers</h5>
                <span>Exciting discounts, promotions and offers</span>
              </div>
            </div>
            <div className="col-md-3 col-6 d-flex pt-3 pb-3 align-items-center">
              <div className="promo-icon">
                <img
                  src="https://john.demo-cst-systems.dreamstechnologies.com/frontend/images/features/202401150154391.png"
                  alt="100% Secure Payment"
                />
              </div>
              <div className="promo-content">
                <h5>100% Secure Payment</h5>
                <span>Pay with confidence on our site</span>
              </div>
            </div>
            <div className="col-md-3 col-6 d-flex pt-3 pb-3 align-items-center">
              <div className="promo-icon">
                <img
                  src="https://john.demo-cst-systems.dreamstechnologies.com/frontend/images/features/202401150155013.png"
                  alt="24/7 Dedicated Support"
                />
              </div>
              <div className="promo-content">
                <h5>24/7 Dedicated Support</h5>
                <span>Get in touch with any query you have</span>
              </div>
            </div> */}
            <div className="row">
              {preFooter?.map((item, index) => (
                <div
                  key={index}
                  className="col-md-3 d-flex pt-3 pb-3 align-items-center"
                >
                  <div className="promo-icon">
                    <img src={item.icon} alt={item.title} />
                  </div>
                  <div className="promo-content">
                    <h5>{item.title}</h5>
                    <span>{item.description}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <div className="footer-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-12">
              <div className="footer-logo">
                <a href="#">
                  <img src={footer?.info?.logo} alt="e-shop" />
                </a>
              </div>
              <div className="footer-text">
                <p>{footer?.info?.description}</p>
              </div>
              <div className="footer-text">
                <p>{footer?.info?.address}</p>
              </div>
              <div className="footer-text">
                <h5 className="text-grey">Need help? Call us:</h5>
                <a href={`tel:${footer?.info?.phone}`}>
                  <h4>{footer?.info?.phone}</h4>
                </a>
              </div>
              <div className="footer-text">
                <a href={`mailto:${footer?.info?.email}`}>
                  <p>{footer?.info?.email}</p>
                </a>
              </div>
              <div className="footer-text">
                {footer?.info?.working_hours.map((hrs: string) => 
                  <p>{hrs}</p>
                )}
              </div>
            </div>

            {footer?.quick_links?.map((data) => (
              <>
                <div className="col-md-2 col-sm-6">
                  <div className="footer-widget">
                    <h3>{data?.title}</h3>
                    <ul className="footer-menu">
                      {data?.links?.map((link) => (
                        <li>
                          <Link
                            to={`${routePrefix}/${link?.slug}`}
                            onClick={() => {
                              if (data?.title == 'Business') {
                                if (isLoggedIn) {
                                  if (link?.slug == 'customer/dashboard') {
                                    dispatch(
                                      setActiveCustomerTab('account-details')
                                    );
                                  }
                                } else {
                                  toast.warn('Please Login to View Page');
                                }
                              }
                            }}
                          >
                            {link?.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </>
            ))}

            <div className="col-md-3 col-12">
              <div className="newsletter">
                <h4>{footer?.newsletter?.title}</h4>
                <p>{footer?.newsletter?.text}</p>
                <form className="mt-5" onSubmit={handleSubmit}>
                  <div className="input-group">
                    <input
                      placeholder="Your email"
                      className="form-control"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button className="button sm style1" type="submit">
                      Subscribe
                    </button>
                  </div>
                </form>

                {/* Feedback Message */}
                {status === 'success' && (
                  <p className="text-success mt-2">Subscribed successfully!</p>
                )}
                {status === 'error' && (
                  <p className="text-danger mt-2">
                    Subscription failed. Try again.
                  </p>
                )}
              </div>
            </div>
          </div>

          <div className="row footer-bottom">
            <div className="col-md-6">
              <p>
                © 2025. All rights reserved. Developed by Dreams Technologies
              </p>
            </div>
            <div className="col-md-6 developed-by">
              {/* Social Icons */}
              <ul className="social-links">
                {header?.social_links?.map((data: any) => (
                  <li>
                    <a href={data?.link} target="_blank" rel="noreferrer">
                      <span
                        dangerouslySetInnerHTML={{ __html: data?.icon }}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Shop Modal */}
      <div
        className="modal fade d-none"
        id="detailsModal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="close offsetmenu__close__btn"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
              <div className="row">
                <div className="col-md-5 modal-image"></div>
                <div className="col-md-7">
                  <h3 className="item-name"></h3>
                  <div className="item-price">
                    <span className="price"></span>
                    <span className="old-price"></span>
                  </div>
                  <div className="item-short-description"></div>
                  <div className="item-options"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cart__menu fixed">
        <i className="material-symbols-outlined">shopping_bag</i>
        <span className="badge badge-light cart_qty">{totalQty}</span>
        <span className="total">
          {currency.symbol}
          {subTotal.toFixed(2)}
        </span>
      </div>
    </>
  );
};

export default React.memo(FooterSection);
